"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = void 0;
var _react = require("react");
var Context = /*#__PURE__*/(0, _react.createContext)({});
exports.Context = Context;